import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { PanButtonComponent } from './pan-button/pan-button.component';
import { PanChipComponent } from './pan-chip/pan-chip.component';
import { PanFloatingLabelComponent } from './pan-floating-label/pan-floating-label.component';
import { PanInlineAlertComponent } from './pan-inline-alert/pan-inline-alert.component';
import { PanSpinnerComponent } from './pan-spinner/pan-spinner.component';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { RoleDirective } from '../directives/role.directive';
import { DragDropFilesDirective } from '../drag-drop-files.directive';
import { PasteFilesDirective } from '../paste-files.directive';
import { AgGridDatetimeComponent } from './ag-grid-datetime/ag-grid-datetime.component';
import { PanActionBarComponent } from './pan-action-bar/pan-action-bar.component';
import { PanBlankSlateComponent } from './pan-blank-slate/pan-blank-slate.component';
import { PanButtonGroupComponent } from './pan-button-group/pan-button-group.component';
import { PanChoiceGroupDirective } from './pan-button-group/pan-choice-group.directive';
import { PanChoiceDirective } from './pan-button-group/pan-choice.directive';
import { PanRadioGroupDirective } from './pan-button-group/pan-radio-group.directive';
import { PanRadioDirective } from './pan-button-group/pan-radio.directive';
import { PanCardComponent } from './pan-card/pan-card.component';
import { PanCheckboxComponent } from './pan-checkbox/pan-checkbox.component';
import { PanDatepickerComponent } from './pan-datepicker/pan-datepicker.component';
import { PanFormControlComponent } from './pan-form-control/pan-form-control.component';
import { PanHelpComponent } from './pan-help/pan-help.component';
import { PanImagePreviewButtonComponent } from './pan-image-preview-button/pan-image-preview-button.component';
import { PanIncidentStatusChipComponent } from './pan-incident-status-chip/pan-incident-status-chip.component';
import { PanIncidentStatusComponent } from './pan-incident-status/pan-incident-status.component';
import { PanInputComponent } from './pan-input/pan-input.component';
import { PanModalCloseDirective } from './pan-modal/pan-modal-close.directive';
import { PanModalComponent } from './pan-modal/pan-modal.component';
import { PanNationalIndicatorComponent } from './pan-national-indicator/pan-national-indicator.component';
import { PanPlanNameComponent } from './pan-plan-name/pan-plan-name.component';
import { PanReportExportComponent } from './pan-report-export/pan-report-export.component';
import { PanSectionHeaderComponent } from './pan-section-header/pan-section-header.component';
import { PanStarRatingComponent } from './pan-star-rating/pan-star-rating.component';
import { PanStatCardComponent } from './pan-stat-card/pan-stat-card.component';
import { PanTextareaComponent } from './pan-textarea/pan-textarea.component';
import { PanTheftStatusComponent } from './pan-theft-status/pan-theft-status.component';
import { PanTimepickerComponent } from './pan-timepicker/pan-timepicker.component';
import { PanTransactionTypeComponent } from './pan-transaction-type/pan-transaction-type.component';
import { PanFilepickerComponent } from './pan-filepicker/pan-filepicker.component';
import { PanVideoStatusChipComponent } from './pan-video-status-chip/pan-video-status-chip.component';
import { PanVideoStatusComponent } from './pan-video-status/pan-video-status.component';
import { PanVideoComponent } from './pan-video/pan-video.component';
import { ResponsiveVisibilityComponent } from './responsive-visibility/responsive-visibility.component';
import { PanDatetimepickerComponent } from './pan-datetime-picker/pan-datetime-picker.component';

const components = [
  PanButtonComponent,
  PanChipComponent,
  PanFloatingLabelComponent,
  PanSpinnerComponent,
  PanInputComponent,
  PanCheckboxComponent,
  PanCardComponent,
  PanButtonGroupComponent,
  PanRadioGroupDirective,
  PanRadioDirective,
  PanChoiceGroupDirective,
  PanChoiceDirective,
  PanTextareaComponent,
  PanDatepickerComponent,
  PanDatetimepickerComponent,
  PanModalComponent,
  PanModalCloseDirective,
  PanFormControlComponent,
  PanInlineAlertComponent,
  PanStatCardComponent,
  PanReportExportComponent,
  PanImagePreviewButtonComponent,
  PanFilepickerComponent,
  PanBlankSlateComponent,
  PanNationalIndicatorComponent,
  PanTheftStatusComponent,
  PanSectionHeaderComponent,
  PanVideoStatusComponent,
  PanVideoStatusChipComponent,
  PanStarRatingComponent,
  PanTransactionTypeComponent,
  PanPlanNameComponent,
  PanIncidentStatusComponent,
  PanIncidentStatusChipComponent,
  ResponsiveVisibilityComponent,
  PanHelpComponent,
  AgGridDatetimeComponent,
  PanVideoComponent,
  PanActionBarComponent,
  PanTimepickerComponent,
  DragDropFilesDirective,
  PasteFilesDirective,
];

const standaloneImports = [RoleDirective];

@NgModule({
  declarations: [...components],
  exports: [NgSelectModule, SweetAlert2Module, ...components, ...standaloneImports],
  imports: [
    CommonModule,
    FormsModule,
    ScrollingModule,
    ReactiveFormsModule,
    MatIconModule,
    NgSelectModule,
    SweetAlert2Module,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatInput,
    MatMenuModule,
    MatSuffix,
    MatProgressBar,
    MatTooltip,
    ...standaloneImports,
  ],
})
export class UiModule {}
